import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ClickAwayListener, Paper, Popper, } from '@mui/material';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { useRefAnchor } from 'shared/hooks/utils';
const style = {
    p: 2,
    fontSize: 16,
    maxWidth: 350,
    whiteSpace: 'pre-line',
};
export const useHelpPopupWithRef = (universal = true) => {
    const [anchorEl, ref, open, close] = useRefAnchor();
    const tooltipProps = useMemo(() => ({
        anchorEl,
        open: Boolean(anchorEl),
        onClose: close,
    }), [anchorEl]);
    const HelpPopup = useMemo(() => {
        const HelpPopupComponent = ({ children, styleProps, ...props }) => {
            if (isSmallUI() && universal) {
                const { anchorEl, ...rest } = tooltipProps;
                return (_jsx(MessageBox, { ...rest, closeButtonTitle: "\u041E\u041A", ...props, children: children }));
            }
            return (_jsx(Popper, { ...tooltipProps, sx: { zIndex: 1500 }, placement: props.placement ?? 'top', ...props, children: _jsx(ClickAwayListener, { onClickAway: tooltipProps.onClose, children: _jsx(Paper, { sx: styleProps ?? style, elevation: 3, children: children }) }) }));
        };
        return HelpPopupComponent;
    }, [tooltipProps, universal]);
    return [HelpPopup, ref, open, close];
};
